
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function SportPilot() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-teal-600 to-teal-700 text-white py-20">
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url('https://readdy.ai/api/search-image?query=light%20sport%20aircraft%20flying%20over%20beautiful%20texas%20landscape%2C%20recreational%20aviation%20scene%20with%20clear%20blue%20skies%2C%20modern%20sport%20pilot%20training%20aircraft%2C%20professional%20aviation%20photography%20with%20warm%20natural%20lighting&width=1200&height=600&seq=sport-pilot-hero&orientation=landscape')`,
            }}
          >
            <div className="absolute inset-0 bg-black/40"></div>
          </div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl">
              <h1 className="text-5xl font-bold mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
                Sport Pilot License
              </h1>
              <h2 className="text-3xl font-semibold mb-4">Half the Cost – Twice the Fun!</h2>
              <p className="text-xl mb-8 leading-relaxed">
                New rules expand privileges with no medical certificate required!
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="tel:706-936-8961" 
                  className="bg-white text-teal-600 px-8 py-3 rounded-md text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-block text-center"
                >
                  Call: 706-936-8961
                </a>
                <a 
                  href="tel:512-658-3132" 
                  className="border-2 border-white text-white px-8 py-3 rounded-md text-lg font-semibold hover:bg-white hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer inline-block text-center"
                >
                  Scott: 512-658-3132
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                  With a Sport Pilot rating you may fly all the classics and more and enjoy everything recreational aviation was meant to be!
                </p>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                  With our basic Sport Pilot training package you may learn to fly as inexpensively as possible in our Cessna taildraggers.
                </p>
                <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                  Earning your Sport Pilot Certificate grants you all the privileges you need to fly for fun with up to one passenger – take a friend and explore the world around you! And completing your Sport Pilot training with us includes a <strong>Tailwheel Endorsement</strong> – with our Sport Pilot program you will be better prepared for any aircraft you may choose to fly in the future!
                </p>
              </div>
              
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=sport%20pilot%20student%20learning%20to%20fly%20in%20cessna%20aircraft%20cockpit%2C%20flight%20instructor%20teaching%20recreational%20aviation%2C%20modern%20flight%20training%20environment%2C%20professional%20aviation%20education%20photography&width=600&height=400&seq=sport-pilot-training&orientation=landscape"
                  alt="Sport pilot training in Central Texas with professional flight instruction"
                  className="rounded-lg shadow-lg object-cover w-full h-96"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Advanced Training Options */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=advanced%20sport%20pilot%20training%20with%20complex%20aircraft%2C%20night%20flying%20training%2C%20controlled%20airspace%20operations%2C%20professional%20aviation%20advancement%20training&width=600&height=400&seq=advanced-sport-pilot&orientation=landscape"
                  alt="Advanced sport pilot training options and aircraft operations"
                  className="rounded-lg shadow-lg object-cover w-full h-96"
                />
              </div>
              
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
                  Want to Do More?
                </h2>
                <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                  With add-on training and logbook endorsements you may learn to fly at night, operate complex aircraft with controllable propellers and retractable landing gear, and operate in controlled airspace at airports with control towers.
                </p>
                
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-moon-line text-teal-600 text-xl"></i>
                    </div>
                    <span className="ml-3 text-gray-700">Night flying training</span>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-settings-3-line text-teal-600 text-xl"></i>
                    </div>
                    <span className="ml-3 text-gray-700">Complex aircraft operations</span>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-radar-line text-teal-600 text-xl"></i>
                    </div>
                    <span className="ml-3 text-gray-700">Controlled airspace operations</span>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-building-line text-teal-600 text-xl"></i>
                    </div>
                    <span className="ml-3 text-gray-700">Control tower airport operations</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Career Advancement */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Barlow, sans-serif' }}>
                Continue Your Aviation Career
              </h2>
              <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
                Should you wish to continue with your aviation career - carry more than one passenger or earn an instrument rating for example - all your flight time and accomplishments as a Sport Pilot count toward achieving a Private Pilot Certificate! You may even earn your Private Pilot certificate with us flying our Cessna 170 taildragger!
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-gray-50 rounded-lg shadow-md p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4 mx-auto">
                  <i className="ri-group-line text-teal-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Carry More Passengers</h3>
                <p className="text-gray-600">
                  Upgrade to Private Pilot to carry multiple passengers and expand your flying adventures.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-md p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4 mx-auto">
                  <i className="ri-compass-line text-teal-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Instrument Rating</h3>
                <p className="text-gray-600">
                  Learn to fly in clouds and poor weather conditions with instrument flight training.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-md p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4 mx-auto">
                  <i className="ri-flight-takeoff-line text-teal-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Flight Time Counts</h3>
                <p className="text-gray-600">
                  All Sport Pilot flight time applies toward your Private Pilot Certificate requirements.
                </p>
              </div>
            </div>

            <div className="text-center mt-12">
              <div className="bg-teal-50 rounded-lg p-8 max-w-3xl mx-auto">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Sport Pilot License Cost</h3>
                <div className="text-center mb-6">
                  <div className="text-3xl font-bold text-teal-600 mb-2">Package Cost $4,500.00</div>
                  <p className="text-lg text-gray-600">(pay as you go)</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="text-2xl font-bold text-gray-900">15 Hrs</div>
                    <p className="text-gray-600">with an instructor</p>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="text-2xl font-bold text-gray-900">5 Hrs</div>
                    <p className="text-gray-600">Solo</p>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="text-2xl font-bold text-gray-900">2 Hrs</div>
                    <p className="text-gray-600">Cross Country</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* Call to Action */}
        <section className="py-16 bg-teal-600 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
              Start Your Sport Pilot Journey Today!
            </h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              Experience the joy of recreational flying with our affordable <strong>sport pilot license </strong> training program. Half the cost, twice the fun!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:706-936-8961" 
                className="bg-white text-teal-600 px-8 py-3 rounded-md text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                Call Bryson: 706-936-8961
              </a>
              <a 
                href="tel:512-658-3132" 
                className="border-2 border-white text-white px-8 py-3 rounded-md text-lg font-semibold hover:bg-white hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                Call Scott: 512-658-3132
              </a>
            </div>
            
            <div className="mt-8">
              <Link 
                to="/" 
                className="text-teal-200 hover:text-white transition-colors"
              >
                ← Back to Home
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
